import ticketDetails from '../localization-messages/ticketDetails/en-GB.json';
import ticketCancelForm from '../localization-messages/ticketCancelForm/en-GB.json';
import ticketListing from '../localization-messages/ticketListing/en-GB.json';
import ticketForm from '../localization-messages/ticketForm/en-GB.json';
import headerFooter from '../localization-messages/headerFooter/en-GB.json';
import reconfirmUserDetailsModal from '../localization-messages/reconfirmUserDetailsModal/en-GB.json';
import termsModal from '../localization-messages/termsModal/en-GB.json';

export const enGBTranslations = {
  ticketDetails,
  ticketCancelForm,
  ticketListing,
  ticketForm,
  headerFooter,
  reconfirmUserDetailsModal,
  termsModal,
};
